/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RetarificationVariableDto } from './RetarificationVariableDto';
import {
    RetarificationVariableDtoFromJSON,
    RetarificationVariableDtoFromJSONTyped,
    RetarificationVariableDtoToJSON,
    RetarificationVariableDtoToJSONTyped,
} from './RetarificationVariableDto';
import type { RetarificationFraisDto } from './RetarificationFraisDto';
import {
    RetarificationFraisDtoFromJSON,
    RetarificationFraisDtoFromJSONTyped,
    RetarificationFraisDtoToJSON,
    RetarificationFraisDtoToJSONTyped,
} from './RetarificationFraisDto';
import type { RetarificationGarantieDto } from './RetarificationGarantieDto';
import {
    RetarificationGarantieDtoFromJSON,
    RetarificationGarantieDtoFromJSONTyped,
    RetarificationGarantieDtoToJSON,
    RetarificationGarantieDtoToJSONTyped,
} from './RetarificationGarantieDto';

/**
 * What a validator can change on a quote (guarantees, ceilings, deductibles, variables, fees) with the current values of the quote, indexed on the tunnel like the comparator.
 * 
 * @export
 * @interface RetarificationModelDto
 */
export interface RetarificationModelDto {
    /**
     * 
     * @type {Array<RetarificationGarantieDto>}
     * @memberof RetarificationModelDto
     */
    garanties: Array<RetarificationGarantieDto>;
    /**
     * 
     * @type {Array<RetarificationVariableDto>}
     * @memberof RetarificationModelDto
     */
    variables: Array<RetarificationVariableDto>;
    /**
     * 
     * @type {Array<RetarificationFraisDto>}
     * @memberof RetarificationModelDto
     */
    frais: Array<RetarificationFraisDto>;
}

/**
 * Check if a given object implements the RetarificationModelDto interface.
 */
export function instanceOfRetarificationModelDto(value: object): value is RetarificationModelDto {
    if (!('garanties' in value) || value['garanties'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    if (!('frais' in value) || value['frais'] === undefined) return false;
    return true;
}

export function RetarificationModelDtoFromJSON(json: any): RetarificationModelDto {
    return RetarificationModelDtoFromJSONTyped(json, false);
}

export function RetarificationModelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationModelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'garanties': ((json['garanties'] as Array<any>).map(RetarificationGarantieDtoFromJSON)),
        'variables': ((json['variables'] as Array<any>).map(RetarificationVariableDtoFromJSON)),
        'frais': ((json['frais'] as Array<any>).map(RetarificationFraisDtoFromJSON)),
    };
}

export function RetarificationModelDtoToJSON(json: any): RetarificationModelDto {
    return RetarificationModelDtoToJSONTyped(json, false);
}

export function RetarificationModelDtoToJSONTyped(value?: RetarificationModelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garanties': ((value['garanties'] as Array<any>).map(RetarificationGarantieDtoToJSON)),
        'variables': ((value['variables'] as Array<any>).map(RetarificationVariableDtoToJSON)),
        'frais': ((value['frais'] as Array<any>).map(RetarificationFraisDtoToJSON)),
    };
}

